import { Outlet, createRoute } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { AreaSidebar, ProductGuard, ProductLayout } from '@/app/routes/area-layout'

export function FlowLayout() {
  return (
    <ProductGuard product="flow">
      <ProductLayout sidebar={<AreaSidebar area="flow" />}>
        <Outlet />
      </ProductLayout>
    </ProductGuard>
  )
}

export const flowRoute = createRoute({
  getParentRoute: () => entityRoute,
  id: 'flow',
  component: FlowLayout,
})
